import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {InventoryControllerService, ProductDto} from '../../@api';
import {environment} from '../../../environments/environment';
import {NgForm} from '@angular/forms';
import {Message} from 'primeng/api';
import {StatePersistenceService} from '../../service/state.persistence.service';
import {AuthenticationManager} from '../../@shared';
import {Router} from '@angular/router';

export interface Product {
    label?: string,
    code?: string,
    price?: number
    subCategory?: string
}

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss', 'mm.submenu.scss']
})
export class NavBarComponent implements OnInit {

    accessProfile: string = environment.access_profile;

    @ViewChild('navBarForm') navBarForm: NgForm;
    errors: Message[] = [];

    uuid: string;

    /** hrefCssClass: used when user clicked on a href on the submenu-container to close the div and unselect the menu item */
    hrefCssClass: string = '';

    /** transitionCssClass: used on mobile devices when item clicked on submenu-container, to delay the ease-out transition */
    transitionCssClass: string = '';

    menuIconCssClass: string = 'active';
    closeIconCssClass: string = '';
    mobileMenuCssClass: string = '';
    productsSubMenuCssClass: string = '';
    solarSubMenuCssClass: string = '';

    inverter: Product = {};
    battery: Product = {};
    complete: Product = {};
    build: Product = {};

    products: ProductDto[] = [];

    constructor(@Inject(DOCUMENT) public document: Document,
                public state: StatePersistenceService,
                public authenticationManager: AuthenticationManager,
                private inventoryControllerService: InventoryControllerService,
                private router: Router) {
        let authenticated: boolean = authenticationManager.isUserAuthenticated();
        console.log('\n\n\nAUTHENTICATED: ' + authenticated + '\n\n\n');
    }

    async ngOnInit(): Promise<void> {
    }

    menuIconClicked(): void {
        this.menuIconCssClass = '';
        this.closeIconCssClass = 'active';
        this.mobileMenuCssClass = 'active'
    }

    closeIconClicked(): void {
        this.closeMegaMenu();
    }

    closeMegaMenu(): void {
        this.closeIconCssClass = '';
        this.menuIconCssClass = 'active';
        this.mobileMenuCssClass = '';
        this.transitionCssClass = '';

        this.productsSubMenuCssClass = '';
        this.solarSubMenuCssClass = '';
    }

    toggleSubMenu(target: string): void {
        // @ts-ignore
        this[target] = this[target] === 'active' ? '' : 'active';
    }

    logout(): void {
        this.authenticationManager.logout();
    }

    navigate(uri: string, delay: number = 0): void {
        if (delay > 0) {
            this.transitionCssClass = 'ease-out-delay';
            setTimeout((): void => {
                this.router.navigateByUrl(uri, {state: {init: true}}).then((r: boolean) => []);
                this.hideSubMenuContainers();
                this.closeMegaMenu();
            }, delay);
        } else {
            this.transitionCssClass = 'ease-out-delay';
            setTimeout((): void => {
                this.router.navigateByUrl(uri, {state: {init: true}}).then((r: boolean) => []);
                this.hideSubMenuContainers();
                this.closeMegaMenu();
            }, 300);
        }
    }

    hideSubMenuContainers(): void {
        this.hrefCssClass = 'targeted';
        this.productsSubMenuCssClass = '';
        this.solarSubMenuCssClass = '';
    }

    resetSubMenuContainers(): void {
        this.hrefCssClass = '';
    }

    print(statement: string): void {
        console.log('print: ' + statement);
    }
}
